import withCloseInAppBrowserButton from './withCloseInAppBrowserButton';

export default withCloseInAppBrowserButton;
